export default __webpack_public_path__ + "static/images/f9f3c423fe75a9098167e5fdacb04907.png";